import { render, staticRenderFns } from "./LiveMain.vue?vue&type=template&id=96149ed0&scoped=true"
import script from "./LiveMain.vue?vue&type=script&lang=js"
export * from "./LiveMain.vue?vue&type=script&lang=js"
import style0 from "./LiveMain.vue?vue&type=style&index=0&id=96149ed0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "96149ed0",
  null
  
)

export default component.exports